import src from "IMAGE";
export default { src, width: 2000, height: 417, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANElEQVR42i3GoQ0AIAwF0UomIYDAsgeCECQJO7D974mKdzmTVDAx4hsqOrKRhI2Pi4cVfxywbTQC9cIaEAAAAABJRU5ErkJggg=="};
